import { getSlidingSafeAreaTop, slidingPageColumnSx } from "./mainStyles";

export const PAGE_HERO_CHARCOAL = "#2C3338";

export const PAGE_HERO_THEMES = {
    home: {
        gradient: "linear-gradient(90deg, #E2F5EE 0%, #FFFDE6 50%, #E8E5F7 100%)",
        titleAlign: "center",
        pb: 1.75,
    },
    library: {
        gradient: "linear-gradient(90deg, #F8E8E0 0%, #E7AA95 48%, #F5D4C8 100%)",
        titleAlign: "left",
        pb: 1.25,
    },
    myPuzzles: {
        gradient: "linear-gradient(90deg, #EDEAF8 0%, #C2B9E7 50%, #DDD6F3 100%)",
        titleAlign: "left",
        pb: 1.25,
    },
    settings: {
        gradient: "linear-gradient(90deg, #EDEAF8 0%, #C2B9E7 50%, #DDD6F3 100%)",
        titleAlign: "left",
        pb: 1,
    },
};

function svgDataUri(svg) {
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

const heroLeftPuzzlesSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="340" viewBox="0 0 300 340"><g fill="none" stroke="#ffffff" stroke-width="2.4" stroke-linejoin="round"><path d="M8 36h48a12 12 0 0 1 12 12v12h12a12 12 0 0 1 12 12v48H56a12 12 0 0 1-12-12V96H8a12 12 0 0 1-12-12V36z" transform="translate(18 28) rotate(-16 44 72)" opacity="0.72"/><path d="M0 0h40a10 10 0 0 1 10 10v10h10a10 10 0 0 1 10 10v40H46a10 10 0 0 1-10-10V80H0a10 10 0 0 1-10-10V0z" transform="translate(4 128) rotate(10 24 52)" opacity="0.5"/><path d="M0 0h56a14 14 0 0 1 14 14v14h14a14 14 0 0 1 14 14v56H68a14 14 0 0 1-14-14V98H0a14 14 0 0 1-14-14V0z" transform="translate(22 198) rotate(-8 36 56)" opacity="0.58"/><path d="M0 0h34a8 8 0 0 1 8 8v8h8a8 8 0 0 1 8 8v34H42a8 8 0 0 1-8-8V58H0a8 8 0 0 1-8-8V0z" transform="translate(72 8) rotate(24 25 34)" opacity="0.42"/></g></svg>`;

const heroRightMeshSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="260" height="260" viewBox="0 0 260 260"><g fill="none" stroke="#ffffff" stroke-width="0.85" opacity="0.62"><path d="M168 18 L208 42 L198 78 L162 86 L142 52 Z"/><path d="M162 86 L198 78 L228 118 L196 142 L158 124 Z"/><path d="M142 52 L162 86 L158 124 L118 112 L108 72 Z"/><path d="M108 72 L118 112 L82 128 L64 94 L88 58 Z"/><circle cx="168" cy="18" r="2.5" fill="#ffffff" stroke="none"/><circle cx="228" cy="118" r="2" fill="#ffffff" stroke="none"/></g></svg>`;

const puzzleTilePatternSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88"><path d="M8 8h26c0 9 9 9 9 9v26H17c0-9-9-9-9-9V8z" fill="none" stroke="#3BA666" stroke-width="1.4"/></svg>`;

const heroLeftPuzzlePattern = svgDataUri(heroLeftPuzzlesSvg);
const heroRightMeshPattern = svgDataUri(heroRightMeshSvg);
export const resumeCardPuzzlePattern = svgDataUri(puzzleTilePatternSvg);

export const pageHeroDecorLeftSx = {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "52%",
    backgroundImage: heroLeftPuzzlePattern,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto 115%",
    backgroundPosition: "left top",
    opacity: 0.55,
    pointerEvents: "none",
    zIndex: 0,
};

export const pageHeroDecorRightSx = {
    position: "absolute",
    right: 0,
    top: 0,
    width: "58%",
    height: "72%",
    backgroundImage: heroRightMeshPattern,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundPosition: "right top",
    opacity: 0.5,
    pointerEvents: "none",
    zIndex: 0,
};

/** Full-bleed hero backdrop (light mode). */
export function pageHeroSectionSx(variant = "home") {
    const theme = PAGE_HERO_THEMES[variant] || PAGE_HERO_THEMES.home;
    const safeTop = getSlidingSafeAreaTop();

    return {
        position: "relative",
        width: "100%",
        mb: variant === "home" ? 1.5 : 1.25,
        pt: `calc(${safeTop} + 0.35rem)`,
        pb: theme.pb,
        px: 0,
        boxSizing: "border-box",
        background: theme.gradient,
        overflow: "hidden",
        isolation: "isolate",
    };
}

/** Hero title + resume card share the same column as page body content. */
export const pageHeroInnerSx = {
    ...slidingPageColumnSx,
    position: "relative",
    zIndex: 1,
};

export function pageHeroTitleSx(variant = "home") {
    const theme = PAGE_HERO_THEMES[variant] || PAGE_HERO_THEMES.home;
    return {
        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
        fontWeight: 700,
        textAlign: theme.titleAlign,
        letterSpacing: "0.08em",
        fontSize: "0.9375rem",
        textTransform: "uppercase",
        color: PAGE_HERO_CHARCOAL,
        textShadow: "0 1px 0 rgba(255, 255, 255, 0.35)",
        flex: theme.titleAlign === "left" ? 1 : undefined,
        minWidth: 0,
    };
}

/** Glass resume card — light-theme spec. */
export function resumeCardLightGlassSx() {
    return {
        position: "relative",
        overflow: "hidden",
        background: "rgba(255, 255, 255, 0.6)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.92)",
        boxShadow: "0 10px 36px rgba(15, 61, 54, 0.07)",
        "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundImage: resumeCardPuzzlePattern,
            backgroundSize: "88px 88px",
            opacity: 0.04,
            pointerEvents: "none",
        },
    };
}

export const resumeCardLightContentSx = {
    position: "relative",
    zIndex: 1,
};

/** @deprecated use PAGE_HERO_CHARCOAL */
export const HOME_HERO_CHARCOAL = PAGE_HERO_CHARCOAL;
